import React from 'react';
import { contactInfo, disclaimer } from '../../data/mock';
import { cities } from '../../data/cities';
import { states } from '../../data/states';
import { FooterStatesBar, FooterCitiesBar } from './FooterMarketBars';
import FooterMain from './FooterMain';

const Footer = () => (
  <footer className="bg-slate-900">
    <FooterStatesBar states={states} />
    <FooterCitiesBar cities={cities} />
    <FooterMain contactInfo={contactInfo} />
    <div className="border-t border-white/10">
      <div className="container mx-auto px-6 py-6">
        <p className="text-xs text-slate-500 text-center leading-relaxed max-w-4xl mx-auto">
          {disclaimer}
        </p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container mx-auto px-6 py-4">
        <p className="text-sm text-slate-500 text-center">
          © {new Date().getFullYear()} DreamHousesUSA. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
